import {useEffect, useState} from "react";
import {runtime} from "../../utils";

const Result = ({q, helpers}: any) => {
  const [ question, setQuestion ] = useState()
  const {results, step} = helpers

  useEffect(()=>{
    if(q && !question) setQuestion(q.question)
  }, [q])

  return <>
    <h2>{question}</h2>
    <br /><br />
    {q?.answers?.map((a: any, i: number) =>
      <div className="answer" key={i}>
        <div className="gauge">
          <div className="gauge__progress" style={{width: `${results[step]?.results[i] || 0}%`}}></div>
        </div>
        <div className="text">{a.answer} <b>({results[step]?.results[i] || 0}%)</b></div>
      </div>
    )}

    <style jsx="true">
      {`
      .answer {
        margin-bottom: 2rem;
      }
        .gauge {
          position: relative;
          width: 100%;
          height: 2rem;
          background: rgb(203 213 225);
          margin-bottom: 1rem;

          .gauge__progress {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 0;
            background: rgb(99 102 241);
            transition: width 1s ease-in-out;
          }
        }
      `}
    </style>
  </>
}

export default Result